module.exports = __webpack_public_path__ + "img/mid-century-modern.372a63c.jpg";